import React from "react";

export const RoundProgress = ({ current, total, stage }) => {
  return (
    <div className="w-full" data-testid="round-progress">
      <div className="flex items-center justify-between mb-2">
        <span className="font-display tracking-widest text-[#00E5FF] text-sm">
          ROUND {current} OF {total}
        </span>
        <span className="text-[10px] tracking-[0.25em] uppercase font-semibold text-[#FDFBF7]/60">
          {stage}
        </span>
      </div>
      <div className="grid grid-cols-5 gap-1.5">
        {Array.from({ length: total }).map((_, i) => (
          <div
            key={`seg-${i}-of-${total}`}
            className={`h-1.5 rounded-full transition-all ${
              i < current - 1 ? "bg-[#00E5FF]/70" : i === current - 1 ? "seg-active" : "bg-white/10"
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export const StageProgress = ({ stage }) => {
  const stages = ["Choose", "Explain", "Predict"];
  const idx = stages.indexOf(stage);
  return (
    <div className="flex items-center gap-2" data-testid="stage-progress">
      {stages.map((s, i) => (
        <div key={s} className="flex items-center gap-2">
          <div
            className={`text-[10px] tracking-[0.2em] font-bold uppercase px-2 py-0.5 rounded-full ${
              i === idx
                ? "bg-[#FF107A] text-[#FDFBF7]"
                : i < idx
                ? "bg-[#00E5FF]/20 text-[#00E5FF]"
                : "bg-white/5 text-[#FDFBF7]/40"
            }`}
          >
            {s}
          </div>
          {i < 2 && <span className="text-[#FDFBF7]/20">•</span>}
        </div>
      ))}
    </div>
  );
};
